/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_Big1_TitleInputs */

const en_mk_ctrl_big1_title = /** @type {(inputs: Mk_Ctrl_Big1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost & duration per feature`)
};

const id_mk_ctrl_big1_title = /** @type {(inputs: Mk_Ctrl_Big1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya & durasi per fitur`)
};

/**
* | output |
* | --- |
* | "Cost & duration per feature" |
*
* @param {Mk_Ctrl_Big1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_big1_title = /** @type {((inputs?: Mk_Ctrl_Big1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_Big1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_big1_title(inputs)
	return en_mk_ctrl_big1_title(inputs)
});